export default {
    assetTypeByType: 'JSON',
    renderAttributes: 'JSON',
}
